import React, { useState, useEffect } from 'react';

function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const AccessorialRateResponse = (props) => {
  const [loaded, setLoaded] = useState(false);
  const [redirect, setRedirect] = useState(null);

  useEffect(async () => {
    try {
      if (window.location.pathname.includes('confirm')) {
        // append token and confirmation to the query string
        setRedirect(`/${window.location.search}&confirmAccessorialRates=true`);
      } else {
        setRedirect(`/${window.location.search}&confirmAccessorialRates=false`);
      }

      await timeout(2000);
      setLoaded(true);
    } catch (e) {
      setRedirect('/');
      setLoaded(true);
      console.log(
        'error appending values to query string',
        props.match.params.id,
        'err:',
        e.message,
      );
    }
  }, []);

  if (!loaded) {
    return (
      <div className="flex justify-center p-16 font-bold">
        Loading Accessorial Rates Data...
      </div>
    );
  }
  window.location.href = redirect;
};

export default AccessorialRateResponse;
